import React, { useEffect, useState } from 'react';

const EmojiBubbles = ({ emoji = '🌟', numberOfEmojis = 100, floatDirection = 'floatUp', floatSpeed = 5, maxSize = 100 }) => {
    const [emojis, setEmojis] = useState([]);

    useEffect(() => {
        // Generate emoji properties
        const generateEmojis = () => {
            const newEmojis = [];
            for (let i = 0; i < numberOfEmojis; i++) {
                const horizontalPosition = floatDirection.includes('LeftToRight') || floatDirection.includes('RightToLeft')
                    ? 'auto'
                    : (i / numberOfEmojis) * 100; // Distributed along X-axis for up/down
                const verticalPosition = floatDirection === 'floatUp'
                    ? 110 // Start 10% below the bottom of the viewport
                    : floatDirection === 'floatDown'
                    ? -10 // Start 10% above the top of the viewport
                    : Math.random() * 100; // Random Y-axis position for left-to-right or right-to-left
                const delay = Math.random() * 5; // Random delay for animation
                const animationDuration = (11 - floatSpeed) + Math.random() * (11 - floatSpeed) * 0.5; // Duration inversely related to speed
                const size = Math.random() * (maxSize - 20) + 20; // Size between 20px and maxSize
    
                newEmojis.push({
                    id: i,
                    horizontalPosition,
                    verticalPosition,
                    delay,
                    animationDuration,
                    size,
                });
            }
            return newEmojis;
        };
    
        setEmojis(generateEmojis());
    }, [numberOfEmojis, floatDirection, floatSpeed, maxSize]);

    return (
        <div style={{ position: 'relative', width: '100%', height: '100vh', overflow: 'hidden' }}>
            {emojis.map(({ id, horizontalPosition, verticalPosition, delay, animationDuration, size }) => (
                <div
                    key={id}
                    style={{
                        position: 'absolute',
                        bottom: floatDirection === 'floatUp' ? '-50px' : 'auto',
                        top: floatDirection === 'floatDown' || floatDirection.includes('LeftToRight') || floatDirection.includes('RightToLeft')
                            ? `${verticalPosition}%`
                            : 'auto',
                        left: floatDirection === 'floatLeftToRight' ? '-50px' : floatDirection === 'floatUp' || floatDirection === 'floatDown' ? `${horizontalPosition}%` : 'auto',
                        right: floatDirection === 'floatRightToLeft' ? '-50px' : 'auto',
                        fontSize: `${size}px`,
                        animation: `${floatDirection} ${animationDuration}s ease-in infinite`,
                        animationDelay: `${delay}s`,
                    }}
                >
                    {emoji}
                </div>
            ))}
            <style>
                {`
                @keyframes floatUp {
                    0% {
                        transform: translateY(0);
                        opacity: 0;
                    }
                    10% {
                        opacity: 1;
                    }
                    100% {
                        transform: translateY(-120vh);
                        opacity: 0;
                    }
                }

                @keyframes floatDown {
                    0% {
                        transform: translateY(0);
                        opacity: 0;
                    }
                    10% {
                        opacity: 1;
                    }
                    100% {
                        transform: translateY(120vh);
                        opacity: 0;
                    }
                }

                @keyframes floatLeftToRight {
                    0% {
                        transform: translateX(0);
                        opacity: 0;
                    }
                    10% {
                        opacity: 1;
                    }
                    100% {
                        transform: translateX(120vw);
                        opacity: 0;
                    }
                }

                @keyframes floatRightToLeft {
                    0% {
                        transform: translateX(0);
                        opacity: 0;
                    }
                    10% {
                        opacity: 1;
                    }
                    100% {
                        transform: translateX(-120vw);
                        opacity: 0;
                    }
                }
                `}
            </style>
        </div>
    );
};

export default EmojiBubbles;

